import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import editFill from '@iconify/icons-ic/drag-handle';
import { Icon } from '@iconify/react';
import CryptoJS from 'crypto-js';
import { useCallback, useState } from 'react';
import { AiFillEdit, AiOutlineCheck, AiOutlineFileAdd } from 'react-icons/ai';
import { BiShareAlt, BiCloudDownload } from 'react-icons/bi';
import { BsCompass, BsFillReplyAllFill } from 'react-icons/bs';
import { FaFileInvoice, FaHandHoldingUsd, FaRegMoneyBillAlt } from 'react-icons/fa';
import { FiCheck, FiEye, FiFileText, FiX } from 'react-icons/fi';
import { GoFilePdf } from 'react-icons/go';
import {
  MdAppRegistration,
  MdUpdate,
  MdModeEdit,
  MdOutlineDateRange,
  MdPayments,
  MdPublishedWithChanges,
  MdReviews,
  MdDownload
} from 'react-icons/md';
import { RiFileCopyLine, RiFlowChart } from 'react-icons/ri';
import { TbCalculator } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
// material
import styled from '@emotion/styled';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import partnerService from '../../../pages/services/partnerService';
import { domainUrl } from '../../../pages/services/globalApi';
import useLoginSelector from '../../../store/Slice/Login/LoginSelector';
import { saveApiData } from '../../../store/Slice/Global/GlobalSlice';
import { OnboardingApi } from '../../../utils/Apis';

const { OnBoardReview } = partnerService;

export default function UserMoreMenu({
  partner,
  rowId,
  assignedTo,
  parent,
  setOpenStatus,
  UpdatePartnerStatusApi,
  partnerState,
  setOpenSendMsg,
  pageMenu,
  companyId,
  applicationId,
  recievableData,
  statusId,
  statusName,
  item,
  itemObj,
  bankId,
  bankName,
  setOpenPayment,
  setBranchEdit,
  setIndividualCommissionEdit,
  setVolumeCommissionEdit,
  setDeleteConfirm,
  itemBranchIndex,
  branchIndex,
  branchEditDialogOpen,
  branchDeleteDialogOpen,
  itemList,
  indexValue,
  individualEditDialogOpen,
  individualDeleteDialogOpen,
  itemListVolume,
  indexValueVolume,
  volumeEditDialogOpen,
  volumeDeleteDialogOpen,
  setEndAgreement,
  handlePublish,
  openEndAgreementDialog,
  aggrementIsActive,
  revenueId,
  leadId,
  handleCopyDialog,
  templateName,
  setSharePopUp,
  setDocumentPreview,
  docPrevHandler,
  statusCode,
  onPayClick,
  deleteUserRow,
  viewUserRow,
  handleRaiseAdvanceRequest,
  handlePaymentAction
}) {
  // console.log('sss usermenu--', partner, rowId);
  // console.log('sss pageMenu', pageMenu);
  const navigate = useNavigate();
  // console.log('rowId in usermoremenu', rowId);
  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  // Styled icon button in Action
  const StyledIconButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    margin: '0 3px',
    [`&:hover`]: {
      color: theme.palette.primary.main
    }
  }));

  async function fireUpdateStateApi(typeid) {
    const statusCredential = {
      companyId: LoginData?.companyId,
      partnerId: rowId,
      partnerStatusTypeId: typeid
    };
    const result = await dispatch(saveApiData(OnboardingApi?.onboardUpdate, statusCredential));
    if (result?.status === 'success') navigate('/partners/');
  }

  if (parent === 'leads') {
    return (
      <>
        <Tooltip
          title="Activity"
          placement="top"
          arrow
          onClick={(e) => {
            const leadObj = {
              leadesItem: [itemObj]
            };
            localStorage.setItem('leadDetails', JSON.stringify(leadObj));
            navigate(`/${parent}/activity`, { state: leadObj });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <BsCompass size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Process"
          placement="top"
          arrow
          disabled={applicationId !== null ? false : true}
          onClick={(e) => {
            const leadObj = {
              leadesItem: [itemObj]
            };
            localStorage.setItem('leadDetails', JSON.stringify(leadObj));
            navigate(`/${parent}/process`, { state: leadObj });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <RiFlowChart size={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'view-recommendation') {
    return (
      <>
        <Tooltip title="View" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={() => {
              const obj = {
                recommendationId: rowId.partnerRecommendationId,
                applicationCreationEntryPlatform: rowId.applicationCreationEntryPlatform
              };
              localStorage.setItem('viewRecommendation', JSON.stringify(obj));
              // console.log('rowIdrowId', rowId);

              const apiCredentialsObj = {
                companyId: rowId?.loanType?.companyId
                  ? rowId?.loanType?.companyId
                  : LoginData?.companyId,
                employmentSubTypeId: {
                  employmentSubcategoryId: rowId?.empSubType?.employmentSubcategoryId,
                  companyId: rowId?.empSubType?.companyId
                    ? rowId?.empSubType?.companyId
                    : LoginData?.companyId,
                  employmentCategoryId: rowId?.empSubType?.employmentCategoryId,
                  employmentSubcategoryCode: rowId?.empSubType?.employmentSubcategoryCode,
                  employmentSubcategoryName: rowId?.empSubType?.employmentSubcategoryName,
                  employmentSubcategoryDescription:
                    rowId?.empSubType?.employmentSubcategoryDescription,
                  employmentSubcategoryIsActive: rowId?.empSubType?.employmentSubcategoryIsActive,
                  employmentSubcategoryDefaultLogo:
                    rowId?.empSubType?.employmentSubcategoryDefaultLogo,
                  employmentSubcategoryCustomLogo:
                    rowId?.empSubType?.employmentSubcategoryCustomLogo,
                  employmentSubcategoryDefaultSeq:
                    rowId?.empSubType?.employmentSubcategoryDefaultSeq,
                  employmentSubcategoryCustomSeq: rowId?.empSubType?.employmentSubcategoryCustomSeq
                },
                employmentTypeId: {
                  employmentCategoryId: rowId?.empType?.employmentCategoryId,
                  companyId: rowId?.empType?.companyId
                    ? rowId?.empType?.companyId
                    : LoginData?.companyId,
                  employmentCategoryCode: rowId?.empType?.employmentCategoryCode,
                  employmentCategoryName: rowId?.empType?.employmentCategoryName,
                  employmentCategoryDescription: rowId?.empType?.employmentCategoryDescription,
                  employmentCategoryDefaultLogo: rowId?.empType?.employmentCategoryDefaultLogo,
                  employmentCategoryCustomLogo: rowId?.empType?.employmentCategoryCustomLogo,
                  employmentCategoryDefaultSeq: rowId?.empType?.employmentCategoryDefaultSeq,
                  employmentCategoryCustomSeq: rowId?.empType?.employmentCategoryCustomSeq,
                  employmentCategoryIsActive: rowId?.empType?.employmentCategoryIsActive
                },
                journeyId: rowId?.journeyId,
                loanSubTypeId: {
                  compId: rowId?.loanSubType?.compId
                    ? rowId?.loanSubType?.compId
                    : LoginData?.companyId,
                  parentLoanId: rowId?.loanSubType?.parentLoanId,
                  loanId: rowId?.loanSubType?.loanId,
                  loanCode: rowId?.loanSubType?.loanCode,
                  loanName: rowId?.loanSubType?.loanName,
                  loanNameToDisplay: rowId?.loanSubType?.loanNameToDisplay,
                  loanDescription: rowId?.loanSubType?.loanDescription,
                  iconPath: rowId?.loanSubType?.iconPath,
                  defaultIconPath: rowId?.loanSubType?.defaultIconPath,
                  isActive: rowId?.loanSubType?.isActive,
                  currentSequence: rowId?.loanSubType?.currentSequence,
                  defaultSequence: rowId?.loanSubType?.defaultSequence
                },
                loanTypeId: {
                  companyId: rowId?.loanType?.companyId
                    ? rowId?.loanType?.companyId
                    : LoginData?.companyId,
                  parentLoanId: rowId?.loanType?.parentLoanId,
                  loanCode: rowId?.loanType?.loanCode,
                  parentLoanName: rowId?.loanType?.parentLoanName,
                  parentLoanDescription: rowId?.loanType?.parentLoanDescription,
                  iconPath: rowId?.loanType?.iconPath,
                  defaultIconPath: rowId?.loanType?.defaultIconPath,
                  isActive: rowId?.loanType?.isActive,
                  currentSequence: rowId?.loanType?.currentSequence,
                  defaultSequence: rowId?.loanType?.defaultSequence
                },
                userId: LoginData?.userId,
                pageCode: LoginData.jwt
              };
              localStorage.setItem('apiCredentials', JSON.stringify(apiCredentialsObj));
              navigate(`${parent}`);
            }}
          >
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip title="Share" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => setSharePopUp(true)}
          >
            <BiShareAlt size={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }

  if (parent === 'print-download') {
    return (
      <Tooltip title="View" placement="top" arrow onClick={(e) => setDocumentPreview(true)}>
        <StyledIconButton className="squareIconButton actionButton">
          <FiEye size={14} />
        </StyledIconButton>
      </Tooltip>
    );
  }

  if (parent === 'print-download-leads') {
    return (
      <Tooltip
        title="View"
        placement="top"
        arrow
        onClick={() => {
          const imgDetailsObj = {};
          imgDetailsObj.src = rowId.path;
          imgDetailsObj.alt = rowId.documentName;
          imgDetailsObj.contentType = rowId.contentType;
          docPrevHandler('open', JSON.stringify(imgDetailsObj));
        }}
      >
        <StyledIconButton className="squareIconButton actionButton">
          <FiEye size={14} />
        </StyledIconButton>
      </Tooltip>
    );
  }
  if (parent === 'login') {
    return (
      <Tooltip
        title="View"
        placement="top"
        arrow
        disabled={rowId.applicationId !== null ? false : true}
        onClick={(e) => {
          const leadObj = {
            leadesItem: [rowId]
          };
          localStorage.setItem('leadDetails', JSON.stringify(leadObj));
          // navigate(`/${parent}/process`);
          navigate(`/${parent}/process`, { state: leadObj });
        }}
      >
        <StyledIconButton className="squareIconButton actionButton">
          <RiFlowChart size={14} />
        </StyledIconButton>
      </Tooltip>
    );
  }
  if (parent === 'revenue') {
    return (
      <>
        <Tooltip title="View File" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => navigate(`/${parent}/view`)}
          >
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip title="Generate Invoice" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => navigate(`/${parent}/invoice`)}
          >
            <FaFileInvoice size={14} />
          </StyledIconButton>
        </Tooltip>
        {/* <Tooltip
          title="Send Message"
          placement="top"
          arrow
          onClick={(e) => {
            setOpenSendMsg(true);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <MdOutlineSendToMobile size={14} />
          </StyledIconButton>
        </Tooltip> */}
      </>
    );
  }
  if (parent === 'revenue-receipt') {
    return (
      <Tooltip title="View File" placement="top" arrow>
        <StyledIconButton
          className="squareIconButton actionButton"
          onClick={(e) => {
            const revenueIdData = {
              revenueId: revenueId,
              leadId: leadId,
              applicationId: applicationId
            };
            localStorage.setItem('revenueIdData', JSON.stringify(revenueIdData));
            navigate(`/revenue/view-receipt`, {
              state: {
                ...rowId
              }
            });
          }}
        >
          <FiEye size={14} />
        </StyledIconButton>
      </Tooltip>
    );
  }
  if (parent === 'revenue-approved') {
    return (
      <Tooltip title="View File" placement="top" arrow>
        <StyledIconButton
          className="squareIconButton actionButton"
          onClick={(e) => {
            const revenueIdData = {
              revenueId: revenueId,
              leadId: leadId,
              applicationId: applicationId
            };
            localStorage.setItem('revenueIdData', JSON.stringify(revenueIdData));
            navigate(`/revenue/view-approved`, {
              state: {
                ...rowId
              }
            });
          }}
        >
          <FiEye size={14} />
        </StyledIconButton>
      </Tooltip>
    );
  }
  if (parent === 'revenue-disbursed') {
    return (
      <Tooltip title="View File" placement="top" arrow>
        <StyledIconButton
          className="squareIconButton actionButton"
          onClick={(e) => {
            const revenueIdData = {
              revenueId: revenueId,
              leadId: leadId,
              applicationId: applicationId
            };
            localStorage.setItem('revenueIdData', JSON.stringify(revenueIdData));
            navigate(`/revenue/view-disbursed`, {
              state: {
                ...rowId
              }
            });
          }}
        >
          <FiEye size={14} />
        </StyledIconButton>
      </Tooltip>
    );
  }
  if (parent === 'payout') {
    return (
      <Stack spacing={1} alignItems="center">
        <Tooltip title="View File" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => {
              const payoutIdData = {
                applicationId: rowId?.applicationId,
                partnerId: rowId?.partnerId,
                partnerPayoutId: rowId?.partnerPayoutId
              };
              localStorage.setItem('payoutIdData', JSON.stringify(payoutIdData));
              navigate(`/${parent}/view`, {
                state: {
                  rowId: rowId
                }
              });
            }}
          >
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Raise Advance Request"
          placement="top"
          arrow
          disabled={rowId?.payoutStatus === 'Mis Matched'}
        >
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={() => handleRaiseAdvanceRequest(rowId)}
          >
            <FaHandHoldingUsd size={14} />
          </StyledIconButton>
        </Tooltip>
      </Stack>
    );
  }

  if (parent === 'advance-pending') {
    return (
      <Box style={{ display: 'flex' }}>
        {console.log('rowId222', rowId)}
        {rowId?.approvalStatus === 'PENDING' &&
        (LoginData?.userType === 'ADMIN' || LoginData?.userType === 'EMPLOYEE') ? (
          <>
            <Tooltip title="Approve" placement="top" arrow>
              <StyledIconButton
                className="squareIconButton actionButton"
                sx={{ color: 'success.main' }}
                onClick={() => statusCode(rowId, 'APPROVED')}
              >
                <FiCheck size={16} />
              </StyledIconButton>
            </Tooltip>

            <Tooltip title="Reject" placement="top" arrow>
              <StyledIconButton
                className="squareIconButton actionButton"
                sx={{ color: 'error.main' }}
                onClick={() => statusCode(rowId, 'REJECTED')}
              >
                <FiX size={16} />
              </StyledIconButton>
            </Tooltip>
          </>
        ) : (
          'N.A.'
        )}
      </Box>
    );
  }

  if (parent === 'call-center') {
    return (
      <>
        <Tooltip title="View" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => {
              localStorage.setItem('viewCallCenterId', rowId);
              navigate('/call-center/view', { state: { rowId } });
            }}
          >
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        {/* <Tooltip title="Recommendation" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => {
              window.open(`http://reco.kalolytic.com/`, `_blank`);
            }}
          >
            <TbCalculator size={14} />
          </StyledIconButton>
        </Tooltip> */}
      </>
    );
  }
  if (parent === 'on-boarding') {
    return (
      <Box sx={{ display: 'flex' }}>
        {pageMenu.length > 0 &&
          pageMenu.map((pageElement, index) => (
            <>
              {pageElement.subPageCode === 'ADD_NEW' && pageElement.isEnable === true ? (
                <Tooltip
                  title="Edit"
                  placement="top"
                  arrow
                  onClick={(e) => {
                    localStorage.setItem('partnerId', rowId);
                    navigate(`/onboarding/edit/${rowId}`, {
                      state: {
                        rowId: partner,
                        parent: 'on-boarding'
                      }
                    });
                  }}
                >
                  <StyledIconButton className="squareIconButton actionButton">
                    <MdModeEdit size={14} />
                  </StyledIconButton>
                </Tooltip>
              ) : pageElement.subPageCode === 'REVIEW' && pageElement.isEnable === true ? (
                <Tooltip
                  title="Review"
                  placement="top"
                  arrow
                  onClick={(e) => {
                    localStorage.setItem('partnerId', rowId);
                    navigate(`/onboarding/review`, { state: { rowId: rowId } });
                    // OnBoardReviewApi(rowId);
                  }}
                >
                  <StyledIconButton className="squareIconButton actionButton">
                    <MdReviews size={14} />
                  </StyledIconButton>
                </Tooltip>
              ) : pageElement.subPageCode === 'SET_COMMISION' && pageElement.isEnable === true ? (
                <Tooltip
                  title="Set Commission"
                  placement="top"
                  arrow
                  onClick={(e) => {
                    localStorage.setItem('partnerId', rowId);
                    navigate(`/onboarding/set-commission`, { state: { rowId: partner } });
                    // OnBoardReviewApi(rowId);
                  }}
                  // onClick={(e) => navigate(`/onboarding/set-commission`)}
                >
                  <StyledIconButton className="squareIconButton actionButton">
                    <FaRegMoneyBillAlt size={14} />
                  </StyledIconButton>
                </Tooltip>
              ) : pageElement.subPageCode === 'ACTIVATE' && pageElement.isEnable === true ? (
                <Tooltip title="Activate" placement="top" arrow>
                  <StyledIconButton
                    classes={{
                      disabled: 'disableButton'
                    }}
                    className="squareIconButton actionButton"
                    onClick={(e) => {
                      UpdatePartnerStatusApi(rowId, partner);
                    }}
                    disabled={
                      partnerState === null ||
                      partner.partnerStatus.typeName === 'Rejected' ||
                      partner.partnerStatus.typeName === 'Activated' ||
                      partner.partnerStatus.typeName === 'Inactive'
                        ? true
                        : false
                    }
                  >
                    <AiOutlineCheck size={14} />
                  </StyledIconButton>
                </Tooltip>
              ) : (
                ''
              )}
              {}
            </>
          ))}
      </Box>
    );
  }
  if (parent === 'invoice') {
    return (
      <>
        &nbsp;
        <Box sx={{ display: 'flex' }}>
          {pageMenu.length > 0 &&
            pageMenu.map((pageElement, index) => (
              <>
                {pageElement.subPageCode === 'RAISE_INVOICE' && pageElement.isEnable === true ? (
                  <>
                    <Tooltip
                      title="Raise Invoice"
                      placement="top"
                      arrow
                      onClick={(e) => navigate(`/${parent}/raise-invoice`)}
                    >
                      <StyledIconButton className="squareIconButton actionButton">
                        <FaFileInvoice size={14} />
                      </StyledIconButton>
                    </Tooltip>
                    &nbsp;
                  </>
                ) : pageElement.subPageCode === 'PAYMENT' && pageElement.isEnable === true ? (
                  <Tooltip
                    title="Payment"
                    placement="top"
                    arrow
                    onClick={(e) => navigate(`/${parent}/payment-invoice`)}
                  >
                    <StyledIconButton className="squareIconButton actionButton">
                      <MdPayments size={14} />
                    </StyledIconButton>
                  </Tooltip>
                ) : (
                  ''
                )}
                {}
              </>
            ))}
        </Box>
      </>
    );
  }
  if (parent === 'receivable-file') {
    return (
      <Box sx={{ display: 'flex' }}>
        <Tooltip title="View" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => {
              const receivableIdData = {
                revenueId: revenueId,
                leadId: leadId,
                applicationId: applicationId,
                recievableData: recievableData
              };
              localStorage.setItem('receivableIdData', JSON.stringify(receivableIdData));
              navigate(`/receivable/view-file`, {
                state: {
                  rowId: recievableData
                }
              });
            }}
          >
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        {/* {console.log('sss recievableDatarecievableData', recievableData)} */}
        {/* <Tooltip
          title="Generate Invoice"
          placement="top"
          arrow
          disabled={recievableData?.misIsMatch === false}
        >
          <StyledIconButton className="squareIconButton actionButton" onClick={(e) => {}}>
            <FiFileText size={14} />
          </StyledIconButton>
        </Tooltip> */}
      </Box>
    );
  }
  if (parent === 'report-file') {
    return (
      <Box sx={{ display: 'flex' }}>
        <Tooltip title="View" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => {
              navigate(`/report/view`);
            }}
          >
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
      </Box>
    );
  }
  if (parent === 'receivable-invoice') {
    return (
      <Box sx={{ display: 'flex' }}>
        <Tooltip title="Pay" placement="top" arrow disabled={statusCode === 'PAID'}>
          <StyledIconButton className="squareIconButton actionButton" onClick={onPayClick}>
            <MdPayments size={14} />
          </StyledIconButton>
        </Tooltip>
        &nbsp;
        <Tooltip title="Download" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={() => viewUserRow(rowId)}
          >
            <MdDownload size={14} />
          </StyledIconButton>
        </Tooltip>
      </Box>
    );
  }

  if (parent === 'data') {
    return (
      <Tooltip
        title="View"
        placement="top"
        arrow
        onClick={(e) => {
          navigate(`/${parent}/view`, {
            state: {
              rowId: rowId,
              record: partner
            }
          });
        }}
      >
        <StyledIconButton className="squareIconButton actionButton">
          <FiEye size={14} />
        </StyledIconButton>
      </Tooltip>
    );
  }
  if (parent === 'receivable-multiple-file') {
    return (
      <Box sx={{ display: 'flex' }}>
        <Tooltip title="Edit" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            // onClick={(e) => navigate(`/receivable/view`)}
          >
            <AiFillEdit size={14} />
          </StyledIconButton>
        </Tooltip>
      </Box>
    );
  }
  if (parent === 'payable') {
    return (
      <Box sx={{ display: 'flex' }}>
        {/* <Tooltip title="Invoice as Pdf" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => navigate('/payable/invoice')}
          >
            <GoFilePdf size={14} />
          </StyledIconButton>
        </Tooltip> */}
        <Tooltip title="View" placement="top" arrow>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => navigate(`/payable/view`, { state: { rowId: rowId } })}
          >
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        {console.log('rowid222', rowId)}
        <Tooltip title="download" disabled={rowId?.partnerId === 0} placement="top" arrow>
          <StyledIconButton
            onClick={() => {
              onPayClick(rowId?.paybleId);
            }}
            className="squareIconButton actionButton"
          >
            <BiCloudDownload size={18} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip title="Pay" placement="top" arrow disabled={rowId?.payableStatus === 'PAID'}>
          <StyledIconButton
            className="squareIconButton actionButton"
            onClick={(e) => {
              if (handlePaymentAction) {
                handlePaymentAction();
              } else if (setOpenPayment) {
                setOpenPayment(true);
              }
            }}
          >
            <MdPayments size={14} />
          </StyledIconButton>
        </Tooltip>
      </Box>
    );
  }

  if (parent === 'prospect') {
    return (
      <Tooltip
        title="View"
        placement="top"
        arrow
        onClick={(e) => {
          localStorage.setItem('prospectLeadId', rowId);
          navigate(`/${parent}/view`);
        }}
      >
        <StyledIconButton className="squareIconButton actionButton">
          <FiEye size={14} />
        </StyledIconButton>
      </Tooltip>
    );
  }
  if (parent === 'master') {
    return (
      <>
        <Tooltip title="Delete" placement="top" arrow>
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip title="View" placement="top" arrow onClick={(e) => navigate(`/${parent}/add`)}>
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'agreement') {
    return (
      <>
        <Tooltip
          title="View &#38; Edit"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('viewAgreementId', rowId);
            localStorage.removeItem('reviewData');
            localStorage.removeItem('commisssionType');
            navigate(`/${parent}/view`, {
              state: {
                rowId: rowId,
                record: partner
              }
            });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        {/* <Tooltip
          title="Add Policy"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.removeItem('reviewData');
            localStorage.removeItem('commisssionType');
            localStorage.setItem('viewAgreementId', rowId);
            localStorage.setItem(
              'bankNameDetails',
              JSON.stringify({
                bankName: bankName,
                bankId: bankId
              })
            );
            navigate(`/${parent}/policy`);
          }}
        >
          <StyledIconButton
            classes={{
              disabled: 'disableButton'
            }}
            className="squareIconButton actionButton"
            disabled={aggrementIsActive === true ? false : true}
          >
            <AiOutlineFileAdd size={14} />
          </StyledIconButton>
        </Tooltip> */}
        <Tooltip
          title="End Agreement"
          placement="top"
          arrow
          onClick={(e) => {
            // setEndAgreement(true);
            openEndAgreementDialog(e, rowId);
          }}
        >
          <StyledIconButton
            classes={{
              disabled: 'disableButton'
            }}
            className="squareIconButton actionButton"
            disabled={aggrementIsActive === null || aggrementIsActive === true ? false : true}
          >
            <MdOutlineDateRange size={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'add-branch-agreement') {
    return (
      <>
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          // onClick={(e) => {
          //   setBranchEdit(true);
          // }}
          onClick={(e) => branchEditDialogOpen(e, itemBranchIndex, branchIndex)}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <AiFillEdit size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Delete"
          placement="top"
          arrow
          onClick={(e) => {
            branchDeleteDialogOpen(e, itemBranchIndex, branchIndex);
            // setDeleteConfirm(true);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'individual-agreement') {
    return (
      <>
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          // onClick={(e) => setIndividualCommissionEdit(true)}
          onClick={(e) => individualEditDialogOpen(e, itemList, indexValue)}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <AiFillEdit size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Delete"
          placement="top"
          arrow
          onClick={(e) => {
            individualDeleteDialogOpen(e, itemList, indexValue);
            // setDeleteConfirm(true);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'volume-agreement') {
    return (
      <>
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          onClick={(e) => {
            // setVolumeCommissionEdit(true);
            volumeEditDialogOpen(e, itemListVolume, indexValueVolume);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <AiFillEdit size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Delete"
          placement="top"
          arrow
          onClick={(e) => {
            volumeDeleteDialogOpen(e, itemListVolume, indexValueVolume);
            // setDeleteConfirm(true);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'policy') {
    return (
      <>
        <Tooltip
          title="View"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('aggrementPolicyId', rowId);
            // localStorage.setItem('viewPolicyAgreementId', viewPolicyAgreementId);
            navigate(`/${parent}/view-policy`, {
              state: {
                rowData: partner
              }
            });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('aggrementPolicyId', rowId);
            // localStorage.setItem('viewPolicyAgreementId', viewPolicyAgreementId);
            navigate(`/${parent}/edit-policy`, {
              state: {
                rowData: partner,
                rowId: rowId,
                pageType: 'Edit'
              }
            });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <AiFillEdit size={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'journey') {
    return (
      <>
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('viewJourneyId', rowId.journeyId);
            localStorage.removeItem('cardTypeListAll');
            localStorage.removeItem('journeyDetailsId');
            localStorage.removeItem('fldListAll');
            localStorage.removeItem('journeybyIdData');
            navigate(`/${parent}/add`, {
              state: {
                rowData: rowId,
                pageType: 'Edit'
              }
            });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <AiFillEdit size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          disabled={rowId.journeyPublished === 'YES' ? true : false}
          title="Publish"
          placement="top"
          arrow
          onClick={() => handlePublish('Publish', rowId.journeyId)}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <MdPublishedWithChanges size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          disabled={rowId.journeyPublished === 'YES' ? true : false}
          title="Delete"
          placement="top"
          arrow
          onClick={() => handlePublish('Delete', rowId.journeyId)}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="View"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('viewJourneyId', rowId.journeyId);
            localStorage.removeItem('cardTypeListAll');
            localStorage.removeItem('journeyDetailsId');
            localStorage.removeItem('fldListAll');
            localStorage.removeItem('journeybyIdData');
            navigate(`/${parent}/view`, {
              state: {
                rowData: rowId
              }
            });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  if (parent === 'journey-template') {
    return (
      <>
        <Tooltip
          title="Copy"
          placement="top"
          arrow
          onClick={(e) => {
            handleCopyDialog(e, rowId, templateName);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <RiFileCopyLine size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="View"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('journeyTemplateId', rowId);
            navigate(`/journey/viewTemplate`);
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
      </>
    );
  }
  // if (parent === 'payable') {
  //   return (
  //     <Box sx={{ display: 'flex' }}>
  //       <Tooltip title="Invoice as Pdf" placement="top" arrow>
  //         <StyledIconButton className="squareIconButton actionButton">
  //           <GoFilePdf size={14} />
  //         </StyledIconButton>
  //       </Tooltip>
  //       <Tooltip title="View" placement="top" arrow>
  //         <StyledIconButton
  //           className="squareIconButton actionButton"
  //           onClick={(e) => navigate(`/payable`)}
  //         >
  //           <FiEye size={14} />
  //         </StyledIconButton>
  //       </Tooltip>
  //       <Tooltip title="Pay" placement="top" arrow>
  //         <StyledIconButton
  //           className="squareIconButton actionButton"
  //           onClick={(e) => navigate(`/payable`)}
  //         >
  //           <MdPayments size={14} />
  //         </StyledIconButton>
  //       </Tooltip>
  //     </Box>
  //   );
  // }
  if (parent === 'users') {
    return (
      <Box>
        <Tooltip
          title="View"
          placement="top"
          arrow
          onClick={() => viewUserRow({ userId: rowId, action: 'view' })}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        {/* <Tooltip title="Delete" placement="top" arrow onClick={() => deleteUserRow(rowId)}>
          <StyledIconButton className="squareIconButton actionButton">
            <Icon icon={trash2Outline} width={14} />
          </StyledIconButton>
        </Tooltip> */}
        <Tooltip
          title="Edit"
          placement="top"
          arrow
          onClick={() => viewUserRow({ userId: rowId, action: 'edit' })}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <MdModeEdit size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Set Incentive"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('partnerId', rowId);
            navigate(`/users/set-incentive-for-employeePartner`, { state: { rowId: rowId } });
            // OnBoardReviewApi(rowId);
          }}
          // onClick={(e) => navigate(`/onboarding/set-commission`)}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FaRegMoneyBillAlt size={14} />
          </StyledIconButton>
        </Tooltip>
      </Box>
    );
  }
  if (parent === 'customer') {
    return (
      <Tooltip
        title="View"
        placement="top"
        className=""
        arrow
        onClick={(e) => {
          navigate(`/${parent}/view`, { state: rowId });
        }}
      >
        <StyledIconButton className="squareIconButton actionButton">
          <FiEye size={14} />
        </StyledIconButton>
      </Tooltip>
    );
  }
  if (parent === 'partner') {
    return (
      <>
        {/* {console.log('sss pageMenu', pageMenu)}
        {console.log('sss in partner', partner)} */}
        {pageMenu.length > 0 &&
          pageMenu.map((pageElement, index) => (
            <>
              {pageElement.subPageCode === 'DELETE' && pageElement.isEnable === true ? (
                <Tooltip
                  title="Delete"
                  placement="top"
                  arrow
                  onClick={() => fireUpdateStateApi(290)}
                >
                  {/* <StyledIconButton className="squareIconButton actionButton">
                    <Icon icon={trash2Outline} width={14} />
                  </StyledIconButton> */}
                </Tooltip>
              ) : pageElement.subPageCode === 'EDIT' && pageElement.isEnable === true ? (
                <Tooltip
                  title="Edit"
                  placement="top"
                  arrow
                  onClick={(e) => {
                    localStorage.setItem('partnerId', rowId);
                    navigate(`/partners/edit/${rowId}`, {
                      state: {
                        rowId: partner,
                        parent: 'partner'
                      }
                    });
                  }}
                >
                  <StyledIconButton className="squareIconButton actionButton">
                    <MdModeEdit size={14} />
                  </StyledIconButton>
                </Tooltip>
              ) : (
                ''
              )}
              {}
            </>
          ))}
        &nbsp;
      </>
    );
  }
  if (parent === 'bankops') {
    return (
      <Stack spacing={1} alignItems="center">
        <Tooltip
          title="View"
          placement="left"
          arrow
          onClick={(e) => {
            localStorage.setItem('selectedItem', JSON.stringify(rowId));
            navigate(`/${parent}/view`, { state: rowId });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip
          title="Decision"
          placement="left"
          arrow
          className={
            rowId.logInStatusName !== 'Sanctioned' && rowId.logInStatusName !== 'Rejected'
              ? 'disabledDocument'
              : ''
          }
          onClick={(e) => {
            localStorage.setItem('selectedItem', JSON.stringify(rowId));
            navigate(`/${parent}/decision`, { state: rowId });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <img
              src="../static/icons/decision.svg"
              alt="Decision"
              className="decisionImg"
              height={14}
            />
          </StyledIconButton>
        </Tooltip>
      </Stack>
    );
  }
  if (parent === 'disburse') {
    return (
      <Stack spacing={1} alignItems="center">
        <Tooltip
          title="View"
          placement="top"
          arrow
          onClick={(e) => {
            localStorage.setItem('selectedItem', JSON.stringify(rowId));
            navigate(`/${parent}/view`, { state: rowId });
          }}
        >
          <StyledIconButton className="squareIconButton actionButton">
            <FiEye size={14} />
          </StyledIconButton>
        </Tooltip>
        <Tooltip title="Approve Disbursement" placement="top" arrow>
          <StyledIconButton
            className={
              rowId.status.toLowerCase() === 'encashment' ||
              rowId.status.toLowerCase() === 'disburse approved' ||
              rowId.status.toLowerCase() === 'encashment approved'
                ? 'squareIconButton actionButton'
                : 'disabledDocument squareIconButton actionButton'
            }
            onClick={(e) => {
              localStorage.setItem('selectedItem', JSON.stringify(rowId));
              navigate(`/${parent}/process`, { state: rowId });
            }}
          >
            <MdUpdate size={14} />
          </StyledIconButton>
        </Tooltip>
      </Stack>
    );
  }

  if (parent === 'rejected') {
    // console.log('rowId22222', rowId);
    return (
      <Tooltip
        title="View"
        placement="top"
        className=""
        arrow
        onClick={() =>
          navigate(`/${parent}/view`, {
            state: { rowId }
          })
        }
      >
        <StyledIconButton className="squareIconButton actionButton">
          <FiEye size={14} />
        </StyledIconButton>
      </Tooltip>
    );
  }

  return (
    <>
      <Tooltip title="Delete" placement="top" arrow>
        <StyledIconButton className="squareIconButton actionButton">
          <Icon icon={trash2Outline} width={14} />
        </StyledIconButton>
      </Tooltip>
      <Tooltip title="Edit" placement="top" arrow>
        <StyledIconButton className="squareIconButton actionButton">
          <Icon icon={editFill} width={14} />
        </StyledIconButton>
      </Tooltip>
    </>
  );
}
